import React from "react";
import { isTrue } from "service/service";
import { Icon, Tooltip } from "antd";

interface StudentNameProps {
    name: string;
    ban: BooleanValue;
    stuHaveExamFlag: BooleanValue;
}

export default function StudentName({
    name,
    ban,
    stuHaveExamFlag
}: StudentNameProps) {
    return (
        <span>
            {name}

            {isTrue(ban) && (
                <Tooltip title="该考生存在缺考、弃考或作弊行为、被老师强制“禁考”。">
                    <Icon type="user-add" />
                </Tooltip>
            )}

            {isTrue(stuHaveExamFlag) && (
                <Tooltip title="考试过程中存在异常行为，请点击“查看详情”查看。">
                    <Icon type="warning" />
                </Tooltip>
            )}
        </span>
    );
}
